import React from 'react';

import { isFunction } from '../../utilities/check';
import EntityState from '../EntityState';
import { Alert } from '@material-ui/lab';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import hardReload from '../../../util/hardReload';
import { ERROR_STATE_TITLE, ERROR_STATE_HINT } from '../errorCopy';

const useStyles = makeStyles(theme => ({
  alert: {
    marginTop: theme.spacing(2),
  },
  reloadButton: {
    marginTop: theme.spacing(3),
  },
}));

export default ({ error, reloadButton, children, ...rest }) => {
  const classes = useStyles();
  const devEnv = import.meta.env.MODE !== 'production';

  if (devEnv) {
    console.error(error);
  }

  return (
    <EntityState icon={'error_outline'} title={ERROR_STATE_TITLE} hint={ERROR_STATE_HINT} {...rest}>
      {reloadButton ? (
        <Button variant="contained" color="primary" className={classes.reloadButton} onClick={hardReload}>
          Try again
        </Button>
      ) : null}
      {devEnv ? (
        <Alert severity="error" className={classes.alert}>
          {error && isFunction(error.toString) && error.toString()}
          {children}
        </Alert>
      ) : null}
    </EntityState>
  );
};
